var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import classnames from 'classnames';
import { DefaultTheme } from '../../Themes';
// Element intended to be used with the Icomoon font library.
const StyledI = styled.i `
  font-family: 'Linearicons';
  speak: none;
  font-style: normal;
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ fontSize }) => fontSize};
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  cursor: ${({ onClick }) => onClick ? 'pointer' : 'default'};

  /* Better font rendering. */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &::before{
    content: '\\${({ icon }) => icon.content}';
  }

  ${({ disabled }) => disabled && css `
    opacity: 0.8;
    pointer-events: none;
  `}
`;
// Element intended to be used with the SVG URLs.
const StyledSvgImage = styled.img `
  width: ${({ width }) => width || '1rem'};
  height: ${({ height }) => height || '1rem'};
`;
const Icon = forwardRef((_a, ref) => {
    var { theme = DefaultTheme, iconUrl, alt, width, height, icon, fontSize = '1rem', fontWeight = 'normal', lineHeight = '1rem', className } = _a, restOfProps = __rest(_a, ["theme", "iconUrl", "alt", "width", "height", "icon", "fontSize", "fontWeight", "lineHeight", "className"]);
    const commonProps = Object.assign(Object.assign({}, restOfProps), { ref,
        theme, className: classnames('icon', className) });
    if (iconUrl) {
        return (React.createElement(StyledSvgImage, Object.assign({ src: iconUrl, alt: alt, width: width, height: height }, commonProps)));
    }
    else if (icon && icon.content) {
        return (React.createElement(StyledI, Object.assign({ icon: icon, fontSize: fontSize, fontWeight: fontWeight, lineHeight: lineHeight }, commonProps)));
    }
    return null;
});
export { Icon };
